import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon, BookIcon } from 'lucide-react';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <>
      {/* Final CTA Section */}
      <section id="comprar" ref={ref} className="w-full py-28 px-6 relative overflow-hidden" style={{
      background: 'linear-gradient(180deg, #0a0a0a 0%, #0d0805 50%, #0a0a0a 100%)'
    }} data-id="element-93">
        {/* Background glow */}
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: `radial-gradient(ellipse at 50% 50%, #CF9B2E 0%, transparent 65%)`
      }} data-id="element-94" />

        <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-95">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.7
        }} data-id="element-96">
            <div className="flag-gradient h-1 w-24 mb-10 mx-auto" data-id="element-97" />

            <p className="text-[#CF9B2E] uppercase tracking-[0.3em] text-sm font-bold mb-6 font-['Lato']" data-id="element-98">
              Es el momento
            </p>

            <h2 className="text-4xl md:text-6xl font-black text-[#F5F0E8] mb-6 leading-tight" data-id="element-99">
              La historia de Venezuela
              <br data-id="element-100" />
              <span className="text-[#CF9B2E]" data-id="element-101">merece ser leída.</span>
            </h2>

            <p className="text-xl md:text-2xl text-[#9A9080] mb-4 leading-relaxed" style={{
            fontFamily: 'Playfair Display, serif',
            fontStyle: 'italic'
          }} data-id="element-102">
              No dejes que el tiempo borre lo que pasó. No permitas que el
              silencio gane.
            </p>

            <p className="text-lg text-[#E8D5B0] mb-12 leading-relaxed" data-id="element-103">
              Por menos de lo que cuesta un café, tienes en tus manos el relato
              más completo y honesto sobre la tragedia venezolana. Un libro que
              te cambiará la perspectiva para siempre.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-[#111111] border border-[#CF9B2E]/30 rounded-sm p-10 mb-10" data-id="element-104">
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-105">
              <span className="text-[#9A9080] text-lg line-through" data-id="element-106">
                $19,99
              </span>
              <span className="bg-[#C0392B] text-white text-xs font-bold px-3 py-1 rounded-full font-['Lato']" data-id="element-107">
                50% DESCUENTO
              </span>
            </div>
            <div className="text-6xl md:text-7xl font-black text-[#CF9B2E] mb-2" data-id="element-108">
              $9,99
            </div>
            <p className="text-[#9A9080] text-sm mb-8 font-['Lato']" data-id="element-109">
              Disponible en formato digital (PDF)
            </p>

            <a href="https://templeofpages.com/cart/48590206533875:1" className="btn-primary inline-block w-full max-w-md px-10 py-6 text-xl rounded-sm font-black tracking-widest" aria-label="Comprar el libro Venezuela ahora por 9,99 USD" data-id="element-110">
              Llévalo ahora por 9,99 USD →
            </a>

            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4 text-[#9A9080] text-sm font-['Lato']" data-id="element-111">
              <span className="flex items-center gap-2" data-id="element-112">
                <ZapIcon className="w-4 h-4 text-[#CF9B2E]" data-id="element-113" />
                Acceso inmediato
              </span>
              <span className="flex items-center gap-2" data-id="element-114">
                <ShieldCheckIcon className="w-4 h-4 text-[#CF9B2E]" data-id="element-115" />
                Pago 100% seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-116">PDF</span>
            </div>
          </motion.div>

          {/* Money-back guarantee */}
          <motion.div initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {}} transition={{
          delay: 0.6
        }} className="flex items-center justify-center gap-4 bg-[#0d0d0d] border border-[#1e1e1e] rounded-sm p-6" data-id="element-117">
            <ShieldCheckIcon className="w-10 h-10 text-[#CF9B2E] flex-shrink-0" data-id="element-118" />
            <div className="text-left" data-id="element-119">
              <p className="text-[#F5F0E8] font-bold mb-1" data-id="element-120">
                Garantía de satisfacción total
              </p>
              <p className="text-[#9A9080] text-sm leading-relaxed" data-id="element-121">
                Si este libro no te conmueve, te devolvemos el dinero. Sin
                preguntas, sin complicaciones. Así de seguros estamos de lo que
                escribimos.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full bg-[#050505] border-t border-[#1a1a1a] py-10 px-6" data-id="element-122">
        <div className="max-w-4xl mx-auto text-center" data-id="element-123">
          <div className="flag-gradient h-px w-24 mx-auto mb-8" data-id="element-124" />
          <p className="text-[#E8D5B0] text-lg mb-2" style={{
          fontFamily: 'Playfair Display, serif',
          fontStyle: 'italic'
        }} data-id="element-125">
            "La verdad no necesita permiso para existir."
          </p>
          <p className="text-[#9A9080] text-sm font-['Lato'] mt-6" data-id="element-126">
            © 2026 Nicolás Pereira — Todos los derechos reservados.
          </p>
          <p className="text-[#4a4a4a] text-xs mt-2 font-['Lato']" data-id="element-127">
            Venezuela — La verdad que el mundo no quiso ver
          </p>
        </div>
      </footer>
    </>;
}